import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";

type BudgetProgressBarProps = {
	utilizationPercent: number;
	showPercentage?: boolean;
};

/**
 * A progress bar component for displaying budget utilization.
 * - Green (primary): under 80%
 * - Yellow (warning): 80-100%
 * - Red (error): over 100%
 */
export const BudgetProgressBar = ({
	utilizationPercent,
	showPercentage = true,
}: BudgetProgressBarProps) => {
	const displayValue = Math.min(utilizationPercent, 100);
	const isOverBudget = utilizationPercent > 100;
	const isWarning = utilizationPercent > 80 && utilizationPercent <= 100;

	const color = isOverBudget ? "error" : isWarning ? "warning" : "primary";

	return (
		<Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
			<Box sx={{ flex: 1, minWidth: 60 }}>
				<LinearProgress
					variant="determinate"
					value={displayValue}
					color={color}
					sx={{ height: 8, borderRadius: 1 }}
				/>
			</Box>
			{showPercentage && (
				<Typography
					variant="caption"
					color={isOverBudget ? "error" : "text.secondary"}
					fontWeight={isOverBudget ? "bold" : "normal"}
					sx={{ minWidth: 40, textAlign: "right" }}
				>
					{utilizationPercent.toFixed(0)}%
				</Typography>
			)}
		</Box>
	);
};
